import React, { useState } from 'react';
import { FormGroup, Modal } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { isEmpty } from 'lodash';
import { useTranslation } from 'react-i18next';
import { useComponent } from '../../UserSetting/UsersLibrary/UserRights';
import CommonMultiSelect from '../../../Components/Utility/FilterAction/CommonMultiSelect';
import CustomTooltip from '../../../Components/Tooltip/CustomTooltip';
import { TEXT_ATTRIBUTE_CHAR_LIMIT_MAX } from './customAttribute.types';

export default function TextCard({
  item,
  index,
  handleChanged,
  activeInactiveClicked,
  handleDelete,
  onChange,
  handleCheckboxCA,
  onDropSelectionChange,
  isUniqueId,
  onDropBrandChange,
}) {
  const { CheckActionPermission } = useComponent();
  const { t } = useTranslation('common');
  const { t: sMaster } = useTranslation('systemMaster');
  const [showConfigModal, setShowConfigModal] = useState(false);
  const reducer = useSelector((estate) => estate);
  const {
    Users: { logInRights },
    SystemMastersDetails: { pcTypeList, brandList },
  } = reducer;

  const MasterDeleteAccess = CheckActionPermission(logInRights, 'masters', 'customAttribute', 'delete');
  const MasterAddEditAccess = CheckActionPermission(logInRights, 'masters', 'customAttribute', 'addEdit');

  return (
    <div className="d-flex flex-wrap mt-2 align-items-center justify-content-center">
      {item?._id !== '' && (
        <div className="checkbox-label ml-2">
          <input
            type="checkbox"
            name={`checkbox_TB${index}`}
            id={`customAttribute_TB_${item?._id}`}
            onChange={handleCheckboxCA}
            checked={item?.isChecked === true}
            disabled={!MasterAddEditAccess}
          />
          <label htmlFor={`customAttribute_TB_${item?._id}`} className="chklabel">
            <span />
          </label>
        </div>
      )}
      <div key={index} className="freetext-container mb-2 flex-fill">
        <div className="input-container">
          <div className="input-group form-floating-label fixed-label">
            <input
              key={index}
              name="freeLabel"
              autoFocus={!item?._id}
              value={item?.keyName ? item?.keyName : ''}
              placeholder={t('TEXT_CARD.FREE_TEXT_TITLE')}
              type="text"
              onChange={(e) => handleChanged(e, index)}
              className="form-control"
              disabled={!MasterAddEditAccess}
            />
            <label className="text-bold f-16 asterisk-req">
              {t('TEXT_CARD.FREE_TEXT_LABEL')}
              <span>*</span>
            </label>
          </div>
          {item?.isEmpty && (item?.keyName === null || item?.keyName === '') && <label className="text-danger m-0 p-1">{t('TEXT_CARD.TEXT_REQUIRED')}</label>}
        </div>
        <div className="input-action d-flex">
          {item?._id !== '' && MasterAddEditAccess && (
            <CustomTooltip tooltipText={item?.isActive ? 'Active' : 'Inactive'}>
              <button
                type="button"
                aria-label={item?.isActive ? 'Active' : 'Inactive'}
                className="btn btn-outline mr-0"
                onClick={() => activeInactiveClicked(item?._id)}
                id={item?._id}
              >
                <span className={item?.isActive ? 'icon-active f-24' : 'icon-inactive f-24'} />
              </button>
            </CustomTooltip>
          )}
          {MasterDeleteAccess && (
            <CustomTooltip tooltipText={t('CUSTOM_ATTRIBUTES.DELETE')}>
              <button
                className="btn btn-outline mr-0"
                type="button"
                aria-label="Delete"
                onClick={() => {
                  handleDelete(item?._id ? item?._id : index);
                }}
              >
                <span className="icon-Delete f-24" />
              </button>
            </CustomTooltip>
          )}
          {MasterAddEditAccess && (
            <CustomTooltip tooltipText={t('TEXT_CARD.CHARACTER_COUNT')}>
              <button type="button" aria-label="Edit" className="btn btn-outline mr-0" onClick={() => setShowConfigModal(true)}>
                <span className="icon-edit f-20" />
              </button>
            </CustomTooltip>
          )}
        </div>
      </div>
      {!isEmpty(isUniqueId) && isUniqueId?.includes(index) && <label className="text-danger m-0 p-1">{t('TEXT_CARD.ENTRY_EXIST')}</label>}
      <div className="product-type-container type-text">
        <CommonMultiSelect
          label={t('TEXT_CARD.PRODUCT_TYPE')}
          required
          onChange={(e) => onDropSelectionChange(e, index)}
          selectedValue={item?.productType || []}
          optionList={pcTypeList?.map((e) => ({
            ...e,
            disabled: item?._id && item?.isUsedProductType?.includes(e._id?.toString()) && item?.productType?.includes(e._id?.toString()),
          }))}
          selectLabel="name"
          selectValue="_id"
          className="product-custom-multiselect common-new-multiselect w-100 text-bold mt-2"
          disable={!MasterAddEditAccess}
        />
        {item?.isEmpty && item?.productType?.length === 0 && <label className="text-danger m-0 p-1">{t('TEXT_CARD.PRODUCT_TYPE_REQUIRED')}</label>}
      </div>
      <div className="product-type-container type-text mt-2">
        <CommonMultiSelect
          label="Brand"
          required
          onChange={(e) => onDropBrandChange(e, index)}
          selectedValue={item?.brand || []}
          optionList={brandList
            ?.filter((e) => e.isActive)
            .map((e) => ({
              ...e,
              disabled: item?._id && item?.isUsedBrand?.includes(e._id?.toString()),
            }))}
          selectLabel="name"
          selectValue="_id"
          className="product-custom-multiselect common-new-multiselect w-100 text-bold mt-2"
          disable={!MasterAddEditAccess}
        />
        {item?.isEmpty && (!item?.brand || item?.brand.length === 0) && <label className="text-danger m-0 p-1">Brand is required</label>}
      </div>

      <Modal
        show={showConfigModal}
        backdrop="static"
        className="common-custom-modal modal-medium"
        aria-labelledby="contained-modal-title-vcenter"
        onHide={() => setShowConfigModal(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>{t('TEXT_CARD.CHARACTER_COUNT')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <FormGroup className="d-flex align-items-center mb-2">
            <input
              type="text"
              inputMode="numeric"
              pattern="[0-9]*"
              maxLength="3"
              className="form-control text-bordered w-80px mr-2"
              value={item?.textFieldConfig?.charLimit ?? ''}
              onKeyDown={(e) => {
                const allowed = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab', 'Home', 'End'];
                if (allowed.includes(e.key)) return;
                if (!/^\d$/.test(e.key)) e.preventDefault();
              }}
              onPaste={(e) => {
                const pasted = e.clipboardData.getData('text');
                if (!/^\d+$/.test(pasted)) e.preventDefault();
              }}
              onChange={(e) => {
                const sanitized = e.target.value.replace(/\D/g, '');
                onChange(sanitized, index, 'textFieldConfig.charLimit');
              }}
            />
            <span>
              {t('TEXT_CARD.CHARACTER_LIMIT')} <small>({sMaster('CUSTOM_ATTRIBUTES.MAX_CHAR_LIMIT', { limit: TEXT_ATTRIBUTE_CHAR_LIMIT_MAX })})</small>
            </span>
          </FormGroup>
          <FormGroup className="mb-2">
            <div className="custom-control custom-switch">
              <input
                type="checkbox"
                className="custom-control-input"
                name="category3CheckBox"
                id={`editableCheck${index}`}
                onChange={(e) => onChange(e.target.checked, index, 'textFieldConfig.isEditable')}
                checked={item?.textFieldConfig?.isEditable}
              />
              <label htmlFor={`editableCheck${index}`} className="custom-control-label">
                <span>{t('TEXT_CARD.EDITABLE_FIELD')}</span>
              </label>
            </div>
          </FormGroup>
          <div className="common-model-footer">
            <button type="button" aria-label="approve" className="btn p-0" onClick={() => setShowConfigModal(false)}>
              <span className="icon-Tick-1 f-24" />
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}
